<template>
  <div>
    <img v-if="isMobile()" src="../assets/ArteMasBanner.gif" width="100%" />
    <img
      v-else
      src="../assets/ArteMasBanner.gif"
      width="100%"
      height="500px"
      class="size-img"
    />
  </div>
  <!-- <div v-swiper:mySwiper="swiperOption">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(img, index) in images" :key="index">
        <img v-if="isMobile()" :src="img.url" width="100%" />
        <img
          v-else
          :src="img.url"
          width="100%"
          height="500px"
          class="size-img"
        />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div> -->
</template>
 
<script>
import mobile_detection from "../mixins/mobile_detection";

export default {
  mixins: [mobile_detection],
  props: {
    images: {
      type: Array,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        // ...
      },
      mySwiper: null,
    };
  },
  mounted() {
    // this.mySwiper = new Swiper(".swiper-pagination", {
    //   autoplay: {
    //     delay: 1000,
    //   },
    // });
    // this.mySwiper.autoplay.start();
    // console.log("Current Swiper instance object", this.mySwiper);
    // this.mySwiper.slideTo(3, 1000, false);
  },
};
</script> 

<style scoped>
.swiper {
  height: 300px;
  width: 100%;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: bold;
}

@media only screen and (max-width: 1500px) {
  .size-img {
    height: 350px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SwiperPagination.vue